import { Link, NavLink, Navigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/admin", label: "Dashboard", id: "admin-tab-dashboard", end: true },
  { to: "/admin/bookings", label: "Bookings", id: "admin-tab-bookings" },
  { to: "/admin/notices", label: "Notices", id: "admin-tab-notices" },
];

export default function AdminLayout({ title, children, testId }) {
  const { user, logout } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center pt-16">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Loading…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (user.role !== "admin") {
    return (
      <div className="mx-auto max-w-lg px-4 pb-24 pt-32 text-center" data-testid="admin-access-denied">
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">
          Admin access required
        </h1>
        <p className="mt-3 text-sm text-slate-600">
          This account ({user.email}) does not have admin permissions.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-blue-900 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-800"
        >
          Back to site
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl px-4 pb-24 pt-28 sm:px-6 lg:px-8" data-testid={testId}>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-900">
            NUC Service Admin
          </p>
          <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-slate-900">
            {title}
          </h1>
        </div>
        <button
          onClick={logout}
          data-testid="admin-logout-button"
          className="inline-flex items-center gap-2 rounded-md border-2 border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition-colors duration-200 hover:border-red-300 hover:text-red-600"
        >
          <LogOut className="h-4 w-4" aria-hidden="true" />
          Sign out
        </button>
      </div>

      <nav className="mt-8 flex gap-2 overflow-x-auto border-b border-slate-200" aria-label="Admin">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={t.id}
            className={({ isActive }) =>
              `whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium transition-colors duration-200 ${
                isActive
                  ? "border-blue-900 text-blue-900"
                  : "border-transparent text-slate-500 hover:text-slate-900"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-8">{children}</div>
    </div>
  );
}
